import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";

function MenuItem({ path, icon, activeIcon, label, children, end }) {
  return (
    <li className="menu__item">
      <NavLink
        to={path}
        end={end}
        className={({ isActive }) =>
          `menu__link${isActive ? " is-active" : ""}`
        }
      >
        {({ isActive }) =>
          icon && activeIcon && label ? (
            <>
              <ReactSVG
                className="menu__icon"
                src={isActive ? activeIcon : icon}
              />
              <span>{label}</span>
            </>
          ) : (
            children
          )
        }
      </NavLink>
    </li>
  );
}

export default MenuItem;
